import React from 'react'
import './Slogan.scss'

function Slogan() {
  return (
    <div id='slogan'>
      <h2 className='sloganText'> AXEL COLLECTION -- STRONGER TOGETHER -- AXEL COLLECTION -- STRONGER TOGETHER -- AXEL COLLECTION -- STRONGER TOGETHER -- AXEL COLLECTION -- STRONGER TOGETHER</h2>
    </div>
  )
}

export default Slogan
